import { route } from 'preact-router';
import { tecnicos, error, success } from '../store/state';
import { editarTecnico } from '../store/actions/user.actions';
import { Shell } from '../layout/Shell';

interface Props {
  id: string;
}

export function EditarTecnicoView({ id }: Props) {
  const t = tecnicos.value.find((x) => x.id === id);

  if (!t) {
    return (
      <Shell tab="perfil">
        <p class="empty">No encontrado.</p>
      </Shell>
    );
  }

  const onSubmit = async (e: Event) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget as HTMLFormElement);
    const payload = Object.fromEntries(fd);
    try {
      await editarTecnico(id, payload);
      success.value = 'Técnico actualizado.';
      route('/perfil');
    } catch (err) {
      error.value = (err as Error).message;
    }
  };

  return (
    <Shell tab="perfil">
      <h2>Editar técnico</h2>
      <form class="form-desktop" onSubmit={onSubmit}>
        <label>Nombre</label>
        <input name="nombre" defaultValue={t.nombre} required />
        <label>Email</label>
        <input name="email" type="email" defaultValue={t.email} required />
        <label>Teléfono</label>
        <input name="telefono" defaultValue={t.telefono} />
        <label>Zona</label>
        <input name="zona" defaultValue={t.zona} />
        <button class="primary" type="submit">
          Guardar cambios
        </button>
        <button class="secondary" type="button" onClick={() => route('/perfil')}>
          Cancelar
        </button>
      </form>
    </Shell>
  );
}
